module.exports = __webpack_public_path__ + "img/registerlogin_3.bdf4fcb1.jpg";